'use client';

import { useState } from 'react';
import { useTranslation } from '@root/src/i18n/client';

export default function NewsletterSection() {
  const { t } = useTranslation('common');
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setEmail('');
      setTimeout(() => setIsSubmitted(false), 3000);
    }
  };

  return (
    <section className="relative w-full bg-gradient-to-b from-[#FBF7F0] to-[#F7F1E6] py-12 md:py-18">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 lg:px-8">
        <div className="rounded-[32px] bg-[#223A27] overflow-hidden">
          {/* Content */}
          <div className="px-6 md:px-12 py-12 md:py-16 text-center">
            <span className="text-xs md:text-sm uppercase tracking-[0.15em] text-[#D4AF37] font-semibold">
              {t('lytra.expNewsletterLabel')}
            </span>
            <h2 className="mt-3 mb-4 text-3xl md:text-4xl font-bold text-white">
              {t('lytra.expNewsletterTitle')}
            </h2>
            <p className="mx-auto mb-8 max-w-2xl text-base text-white/80 leading-relaxed">
              {t('lytra.expNewsletterDesc')}
            </p>

            {/* Newsletter Form */}
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('lytra.expNewsletterPlaceholder')}
                className="flex-1 rounded-full bg-white px-6 py-3 text-sm text-[#223A27] placeholder:text-[#999] outline-none transition-all focus:ring-2 focus:ring-[#D4AF37]"
                required
              />
              <button
                type="submit"
                className="whitespace-nowrap rounded-full bg-[#D4AF37] px-8 py-3 font-semibold text-[#223A27] hover:bg-[#C19B1A] transition-colors"
              >
                {t('lytra.expNewsletterButton')}
              </button>
            </form>

            {/* Success Message */}
            {isSubmitted && (
              <div className="mt-4 text-sm text-[#D4AF37] font-semibold">
                {t('lytra.expNewsletterSuccess')}
              </div>
            )}
          </div>

          {/* Decorative Element */}
          <div className="hidden md:block absolute -bottom-8 -right-8 opacity-10">
            <div className="text-9xl">🍵</div>
          </div>
        </div>
      </div>
    </section>
  );
}
